import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { GlobalStateProvider } from './state';
import LandingPage from './LandingPage';
import HelpPage from './LandingPage/help.js';

const isLandingPage = window.location.pathname === '/';

const isHelpPage = window.location.pathname === '/help';

ReactDOM.render(
  <GlobalStateProvider>
    {isLandingPage ? <LandingPage /> : isHelpPage ? <HelpPage /> : <App />}
  </GlobalStateProvider>
  , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
